import React from "react";

const TandV = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Libraries & Frameworks</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Pandas</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">NumPy</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Matplotlib</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          {/* Add more skills if needed */}
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Seaborn</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">DuckDB</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Scikit-Learn</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>

          {/* Add more skills if needed */}
        </div>
      </div>
    </div>
  );
};

export default TandV;
